module.exports = __webpack_public_path__ + "static/media/Edenredlogo.51f3afc2.svg";